import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import { AppBar, Toolbar } from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from './components/Logo';

const useStyles = makeStyles()((theme) => ({
    appBar: {
        display: 'flex',
        justifyContent: 'center',
        position: 'fixed',
        background: "#313235",
        top: 0,
    },
    link: {
        height: "100%",
        width: "100%",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}));

const MobileHeader = () => {
    const { classes } = useStyles();

    return (
        <AppBar className={classes.appBar}>
            <Toolbar>
                <Link to="/videos" className={classes.link}>
                    <Logo height={30} />
                </Link>
            </Toolbar>
        </AppBar>
    );
}

export default memo(MobileHeader);